import { css } from 'react-strict-dom';

const Style = css.create({
  row: {
    display: 'flex',
    flexDirection: 'row',
  },
  col: {
    display: 'flex',
    flexDirection: 'column',
  },
  inline: {
    display: 'inline-flex',
  },
  centerBoth: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  alignCenter: {
    alignItems: 'center',
  },
  alignStart: {
    alignItems: 'flex-start',
  },
  alignEnd: {
    alignItems: 'flex-end',
  },
  spaceBetween: {
    justifyContent: 'space-between',
  },
  justifyCenter: {
    justifyContent: 'center',
  },
  justifyEnd: {
    justifyContent: 'flex-end',
  },
  wrap: {
    flexWrap: 'wrap',
  },
  fill: {
    flex: 1,
  },
  shrink0: {
    flexShrink: 0,
  },

  positionRelative: {
    position: 'relative',
  },

  hideAboveXs: {
    display: {
      default: 'flex',
      '@media (min-width: 576px)': 'none',
    },
  },
  hideAboveSm: {
    display: {
      default: 'flex',
      '@media (min-width: 768px)': 'none',
    },
  },
  hideAboveMd: {
    display: {
      default: 'flex',
      '@media (min-width: 992px)': 'none',
    },
  },
  hideAboveLg: {
    display: {
      default: 'flex',
      '@media (min-width: 1200px)': 'none',
    },
  },
  hideAboveXl: {
    display: {
      default: 'flex',
      '@media (min-width: 1400px)': 'none',
    },
  },
  hideBelowXs: {
    display: {
      default: 'flex',
      '@media (max-width: 575px)': 'none',
    },
  },
  hideBelowSm: {
    display: {
      default: 'flex',
      '@media (max-width: 767px)': 'none',
    },
  },
  hideBelowMd: {
    display: {
      default: 'flex',
      '@media (max-width: 991px)': 'none',
    },
  },
  hideBelowLg: {
    display: {
      default: 'flex',
      '@media (max-width: 1199px)': 'none',
    },
  },
  hideBelowXl: {
    display: {
      default: 'flex',
      '@media (max-width: 1399px)': 'none',
    },
  },
});

export default Style;
